var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "b54a45f0ff44d3c8f637d9b99456c17a86554251"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["javascript-gatsby@claimscore-2f"] = {
  id: "b54a45f0ff44d3c8f637d9b99456c17a86554251"
};